import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ActivitySession } from '../../activity-logger';
import { ActivityData } from '../../activity-data';

export type NavigationActivityHandler = (
    parameters: {
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        activitySession: Observable<ActivitySession>
    }
) => Observable<ActivityData>;

export interface NavigationActivityRouteData {
    navigationActivityHandler: NavigationActivityHandler;
}

export const navigationActivityHandler = (handler: NavigationActivityHandler): NavigationActivityRouteData => (
    {
        navigationActivityHandler: handler
    }
);